import visibilityActionType from "./visibilityActionTypes";

const fetchPending = () => ({
  type: visibilityActionType.FETCH_VISIBILITY_PENDING,
});

const fetchSuccess = (data) => ({
  type: visibilityActionType.FETCH_VISIBILITY_SUCCESS,
  data: data,
});

const fetchError = (message) => ({
  type: visibilityActionType.FETCH_VISIBILITY_ERROR,
  data: message,
});

const fetchAllPending = () => ({
  type: visibilityActionType.FETCH_ALL_PENDING,
});

const fetchAllSuccess = (data) => ({
  type: visibilityActionType.FETCH_ALL_SUCCESS,
  data,
});

const fetchAllError = (message) => ({
  type: visibilityActionType.FETCH_ALL_ERROR,
  message,
});

const fetchAllRolesPending = () => ({
  type: visibilityActionType.FETCH_ALL_ROLES_PENDING,
});

const fetchAllRolesSuccess = (data) => ({
  type: visibilityActionType.FETCH_ALL_ROLES_SUCCESS,
  data,
});

const fetchAllRolesError = (message) => ({
  type: visibilityActionType.FETCH_ALL_ROLES_ERROR,
  message,
});

const editPending = () => ({
  type: visibilityActionType.EDIT_PENDING,
});

const editDone = () => ({
  type: visibilityActionType.EDIT_DONE,
});

const setFilter = (data) => ({
  type: visibilityActionType.SET_FILTER,
  data,
});

export default {
  fetchPending,
  fetchSuccess,
  fetchError,
  fetchAllPending,
  fetchAllSuccess,
  fetchAllError,
  fetchAllRolesPending,
  fetchAllRolesSuccess,
  fetchAllRolesError,
  editPending,
  editDone,
  setFilter,
};
